import { render, staticRenderFns } from "./MicrolearningViewEdit.vue?vue&type=template&id=0d8bebec&scoped=true"
import script from "./MicrolearningViewEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./MicrolearningViewEdit.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MicrolearningViewEdit.vue?vue&type=style&index=0&id=0d8bebec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8bebec",
  null
  
)

export default component.exports